import { getPath } from '@/router/common'

const baseUrl = {
  title: '蓝桥商城',
  path: 'newLqMall'
}
export default[
    // {
    //   path: getPath('newLqMall', baseUrl),
    //   name: 'newLqMall',
    //   component: () => import('@/views/newLqMall/newLqMall/index.vue'),
    //   meta: {
    //     title: '蓝桥商城'
    //   }
    // },
    // {
    //   path: getPath('newLqMallOrder', baseUrl),
    //   name: 'newLqMallOrder',
    //   component: () => import('@/views/newLqMall/newLqMallOrder/index.vue'),
    //   meta: {
    //     title: '蓝桥订单'
    //   }
    // },
    // {
    //   path: getPath('mallGoodsDetail', baseUrl),
    //   name: 'mallGoodsDetail',
    //   component: () => import('@/views/newLqMall/mallGoodsDetail/index.vue'),
    //   meta: {
    //     title: '商品详情'
    //   }
    // },
    // 落地配
    {
      path: getPath('langingDetail', baseUrl),
      name: 'langingDetail',
      component: () => import('@/views/newLqMall/langingDetail/index.vue'),
      meta: {
        title: '商品详情'
      }
    }
]
